import { generalBlue } from 'src/app-config';
import { lastUpdateNewsPage } from '../news-page/NewsPage';
import { localStorageHelper } from '../../services';
import { logoutReducer, setAlertResponse, setValuesAndOpenAlertModalReducer } from 'src/store';
import { millisecondsSevenDays } from '@monorepo/helpers';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser, useGetIsMobile } from 'src/custom-hooks';
import { useLocation, useNavigate } from 'react-router';
import { useMemo, useState } from 'react';
import { userServices } from 'src/services';

const color = '#fbfbfb';

export const NavBar = () => {
    const [expanded, setExpanded] = useState(false);
    const dispatch = useDispatch();
    const isMobile = useGetIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const user = useGetCurrentUser();
    
    const classes = `${isMobile ? 'border-bottom py-3' : ''} px-3`;
    const isActive = (url: string) => location.pathname === url ? 'bold' : 'normal';

    const openLogoutConfirmModal = (): void => {
        setExpanded(false)
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: '¿Cerrar sesión?',
            message: '',
            execution: async () => {
                userServices.Logout();
                dispatch(logoutReducer());
                navigate('/acceso');
            }
        }));
    }

    const navigateHandler = (url: string): void => {
        setExpanded(false);
        navigate(url);
    }

    const showAnimationOnNewsLink: boolean = useMemo(() => {
        const lastVisit = localStorageHelper.GetNewsVisited();
        const alreadyVisited = !!lastVisit && lastVisit > lastUpdateNewsPage;
        const isOnWeek = Date.now() < lastUpdateNewsPage + millisecondsSevenDays;
        return isOnWeek && !alreadyVisited;
    }, [window.location.pathname]);

    return (
        <Navbar expanded={expanded} style={{ backgroundColor: generalBlue, zIndex: 9000 }} expand={'lg'}>
            {expanded &&
                <style>{'.hide-for-navbar {display: none;}'}</style>
            }
            <Container fluid>
                <Navbar.Brand className={'pointer ps-2'}
                    style={{ color, fontWeight: isActive('/') }}
                    onClick={() => isMobile ? null : navigateHandler('/')} 
                >
                    {!isMobile && 'INICIO'}
                </Navbar.Brand>
                <Navbar.Toggle onClick={() => setExpanded(x => !x)} />
                <Navbar.Collapse>
                    <Nav className={'me-auto'}>
                        {user.isAuth ?
                            <>
                            {isMobile &&
                                <Nav.Link className={(classes + ' border-top mt-3')}
                                    style={{ color, fontWeight: isActive('/') }}
                                    onClick={() => navigateHandler('/')}
                                >
                                    Inicio
                                </Nav.Link>
                            }
                            <Nav.Link className={classes}
                                style={{ color, fontWeight: isActive('/tablero') }}
                                onClick={() => navigateHandler('/tablero')}
                            >
                                Tablero
                            </Nav.Link>
                            <Nav.Link className={classes}
                                style={{ color, fontWeight: isActive('/casa-en-casa') }}
                                onClick={() => navigateHandler('/casa-en-casa')}
                            >
                                Casa en Casa
                            </Nav.Link>
                            {user.congregation === 1 &&
                                <Nav.Link className={classes}
                                    style={{ color, fontWeight: isActive('/telefonica') }}
                                    onClick={() => navigateHandler('/telefonica')}
                                >
                                    Telefónica
                                </Nav.Link>
                            }
                            {/* {user.isCartsAdmin &&
                                <Nav.Link className={classes}
                                    style={{ color, fontWeight: isActive('/carritos') }}
                                    onClick={() => navigateHandler('/admins/carritos')}
                                >
                                    Carritos
                                </Nav.Link>
                            } */}
                            </>
                            :
                            <Nav.Link className={classes}
                                style={{ color, fontWeight: isActive('/acceso') }}
                                onClick={() => navigateHandler('/acceso')}
                            >
                                Entrar
                            </Nav.Link>
                        }
                        {(user.isBoardAdmin || user.isCartsAdmin || user.isHthAdmin || user.isMeetingsAdmin || user.isTelephonicAdmin) &&
                            <Nav.Link className={classes}
                                onClick={() => navigateHandler('/admins')}
                                style={{ color, fontWeight: isActive('/admins') }}
                            >
                                Administradores
                            </Nav.Link>
                        }
                    </Nav>
                    {user.isAuth &&
                        <Nav>
                            <Nav.Link className={classes}
                                style={{
                                    fontWeight: isActive('/usuario')
                                }}
                                onClick={() => navigateHandler('/usuario')}
                            >
                                <span style={{ color }}>
                                    Mi Usuario
                                </span>
                            </Nav.Link>
                            <Nav.Link
                                className={`${showAnimationOnNewsLink ?
                                    isMobile ? 'animate__animated animate__flash animate__infinite infinite' : 'animate__animated animate__pulse animate__infinite infinite'
                                    :
                                    ''} ${classes}`
                                }
                                style={{
                                    fontWeight: isActive('/novedades')
                                }}
                                onClick={() => navigateHandler('/novedades')}
                            >
                                <span style={{ color }}>
                                    Novedades
                                </span>
                            </Nav.Link>
                            <Button className={isMobile ? 'my-3' : ''}
                                variant={'outline-info'}
                                style={{ color, borderColor: color }}
                                onClick={() => openLogoutConfirmModal()}
                            >
                                CERRAR SESIÓN
                            </Button>
                        </Nav>
                    }
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
